import { Avatar } from "@circle-react-uikit/SkeletonLoader/components/Avatar";
import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";

export const MemberCardWithConnectionSkeleton = () => (
  <li
    className="bg-primary outline-primary relative inline-flex h-[274px] flex-col items-center justify-between overflow-hidden rounded-xl px-3 pb-4 pt-3 outline outline-1 outline-offset-[-1px]"
    data-testid="member-card-skeleton"
  >
    <div className="flex w-full flex-col items-center justify-start gap-4 rounded-md py-4">
      <div className="size-24">
        <Avatar lg />
      </div>
      <div className="flex w-full flex-col items-center justify-start gap-2.5">
        <div className="flex w-full flex-col items-center justify-start gap-1">
          <Row md long />
          <Row sm half />
        </div>
        <div className="flex w-full items-center justify-center gap-1 px-2">
          <Row xs short />
        </div>
      </div>
    </div>
    <div className="inline-flex w-full items-start justify-start gap-2 px-1">
      <Row md className="!h-9 !w-full !rounded-full" />
    </div>
  </li>
);
